import {
    FORM_TRACKING_FORM_NAME_ATTR,
    FORM_TRACKING_FORM_STEP_INDEX_ATTR,
    FORM_TRACKING_FORM_STEP_NAME_ATTR,
} from '../FormTrackingSettings'

type FormStepData = {
    form_name: string
    tm_index: string
    tm_name: string
}

const defaultFormStep = (formId: string): FormStepData => ({
    form_name: formId,
    tm_index: '1',
    tm_name: formId,
})

export const resolveFormStepData = (formId: string): FormStepData => {
    const formElement = document?.getElementById(formId)
    if (!formElement) {
        return defaultFormStep(formId)
    }

    const stepHost =
        formElement.closest(`[${FORM_TRACKING_FORM_STEP_INDEX_ATTR}]`) ??
        formElement.querySelector(`[${FORM_TRACKING_FORM_STEP_INDEX_ATTR}]`)

    if (!stepHost) {
        return defaultFormStep(formId)
    }

    const form_name = stepHost.getAttribute(FORM_TRACKING_FORM_NAME_ATTR) || formId
    const tm_index = stepHost.getAttribute(FORM_TRACKING_FORM_STEP_INDEX_ATTR) || '1'
    const stepName = stepHost.getAttribute(FORM_TRACKING_FORM_STEP_NAME_ATTR)
    const tm_name = !!stepName?.length ? stepName : form_name

    return { form_name, tm_index, tm_name }
}
